export const immersiveSaveButtonContainerId =
  'immersive-trip-header-save-button-container'
